"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = paramsConvertTable;
var _common = require("../utils/common");
var _constant = require("../constant");
/**
 * 将外部传入的查询条件，解析成dataManager能理解的table对象列表
 * @param {*} options 统一的外部入参格式
 */
function paramsConvertTable(tableList, allTableParams) {
  var _tableList$find;
  var page = allTableParams.page,
    size = allTableParams.size,
    include = allTableParams.include,
    exclude = allTableParams.exclude,
    filter = allTableParams.filter,
    sort = allTableParams.sort;
  var mainTableKey = (_tableList$find = tableList.find(function (table) {
    return table.isMain;
  })) === null || _tableList$find === void 0 ? void 0 : _tableList$find.tableKey;
  if (!(0, _common.noneValue)(page)) {
    var paramsObj = {};
    paramsObj[mainTableKey] = page;
    setTableParams(tableList, paramsObj, 'page');
  }
  if (!(0, _common.noneValue)(size)) {
    var _paramsObj = {};
    _paramsObj[mainTableKey] = size;
    setTableParams(tableList, _paramsObj, 'size');
  }
  fieldFliter(tableList, mainTableKey, include, 'include');
  fieldFliter(tableList, mainTableKey, exclude, 'exclude');
  dataFliter(tableList, mainTableKey, filter);
  fieldSort(tableList, mainTableKey, sort);
}

/**
 * 设置表的初始筛选条件（tableParams）
 * @param {*} tableList 所有表对象集
 * @param {*} tableKey 指定表key
 * @param {*} tableParams 指定表的参数配置
 * @returns
 */
function setTableParams(tableList, paramObj, type) {
  tableList.forEach(function (table) {
    var tableParams = table.tableParams,
      tableKey = table.tableKey;
    var value = paramObj[tableKey];
    if (value) {
      tableParams[type] = value;
    }
  });
}

/**
 * 表的字段筛选
 * @param {*} tableList 所有表对象集
 * @param {*} mainTableKey 主表key
 * @param {*} fieldArray 所有的字段过滤集合
 * @param {*} type 过滤类型：include、exclude
 */
function fieldFliter(tableList, mainTableKey, fieldArray, type) {
  var paramObj = {};
  (fieldArray || []).forEach(function (item) {
    if (!item) return;
    var tableKey = mainTableKey;
    var field;
    var spiltArray = item.split('.');
    if (spiltArray[0].startsWith(_constant.TABLETAG) && spiltArray.length === 2) {
      tableKey = spiltArray[0].substring(1);
      // eslint-disable-next-line
      field = spiltArray[1];
    } else {
      field = item;
    }
    paramObj[tableKey] = paramObj[tableKey] || [];
    paramObj[tableKey].push(field);
  });
  Object.keys(paramObj).forEach(function (key) {
    paramObj[key] = paramObj[key].join(',');
  });
  setTableParams(tableList, paramObj, type);
}

/**
 * 表的数据筛选
 * @param {*} tableList 所有表对象集
 * @param {*} mainTableKey 主表key
 * @param {*} dataArray 所有的字段过滤集合
 */
function dataFliter(tableList, mainTableKey, dataArray) {
  var paramObj = {};
  (dataArray || []).forEach(function (item) {
    var k = item.k,
      v = item.v,
      o = item.o;
    if (!k) return;
    var tableKey = mainTableKey;
    var field;
    var spiltArray = k.split('.');
    if (spiltArray[0].startsWith(_constant.TABLETAG) && spiltArray.length === 2) {
      tableKey = spiltArray[0].substring(1);
      // eslint-disable-next-line
      field = spiltArray[1];
    } else {
      field = k;
    }
    paramObj[tableKey] = paramObj[tableKey] || [];
    paramObj[tableKey].push({
      k: field,
      v: v,
      o: o
    });
  });
  setTableParams(tableList, paramObj, 'filter');
}

/**
 * 表的字段排序筛选
 * @param {*} tableList 所有表对象集
 * @param {*} mainTableKey 主表key
 * @param {*} dataArray 所有的字段过滤集合
 */
function fieldSort(tableList, mainTableKey, fieldArray) {
  var paramObj = {};
  (fieldArray || []).forEach(function (item) {
    var k = item.k,
      o = item.o;
    if (!k) return;
    var tableKey = mainTableKey;
    var field;
    var spiltArray = k.split('.');
    if (spiltArray[0].startsWith(_constant.TABLETAG) && spiltArray.length === 2) {
      tableKey = spiltArray[0].substring(1);
      // eslint-disable-next-line
      field = spiltArray[1];
    } else {
      field = k;
    }
    paramObj[tableKey] = paramObj[tableKey] || [];
    paramObj[tableKey].push({
      k: field,
      o: o
    });
  });
  setTableParams(tableList, paramObj, 'sort');
}